import { useApiAWS } from '@/composables/useApi'

const apiAws = useApiAWS()

export function UploadVideoService() {
  this.mediaConvert = function (params) {
    return apiAws.post('/media-convert', params).then(res => res.data)
  }

  this.monitorarConversao = function (JobId) {
    return apiAws.get(`/job/${JobId}`).then(res => res.data)
  }
}
